import React from 'react';
import styled from 'styled-components';
import { EmptyList } from 'src/components/widgets/emptyList';
import { T } from 'src/shared/helpers';
import MdReportProblem from 'src/shared/material_icons/alert/warning.svg';
import { Link } from 'src/components/widgets/buttons';
import { ContainerBase } from 'src/components/widgets/layouts';

const Container = styled(ContainerBase)`
    margin-top: 160px;
`;

const NotFoundIcon = styled(MdReportProblem)`
    width: 128px;
    height: 128px;
`;

const NotFoundPage = () => (
    <Container>
        <EmptyList
            title={T._('Page not found :(', 'Admin')}
            subTitle={
                <>
                    {T._('Please contact us at:', 'Admin')} <Link href='mailto:help@zakeke.com'>help@zakeke.com</Link>
                </>
            }
            icon={<NotFoundIcon />}
        />
    </Container>
);

export default NotFoundPage;
